import { useLocation } from 'react-router';
import ReportRunner from '../../components/report/report-runner';
import { ReportType } from '../../models/enumerations/report-type';
import { Utils } from '../../utilities/utils';
import { useTranslation } from 'react-i18next';

// -----------------------------------------------------------------------------------------
// #region Intefaces
// -----------------------------------------------------------------------------------------

interface GenerateReportPageProps { }

// #endregion Intefaces

// -----------------------------------------------------------------------------------------
// #region Component
// -----------------------------------------------------------------------------------------

const GenerateReportPage: React.FC<GenerateReportPageProps> = (props: GenerateReportPageProps) => {
    const location = useLocation();

    const { reportId, type, userId, language } = Utils.parseQueryString(location.search);

    const { i18n } = useTranslation();

    if (language) {
        i18n.changeLanguage(language);
    }

    let reportType = ReportType.Compliance;

    switch (type) {
        case "0":
            reportType = ReportType.Compliance;
            break;
        case "1":
            reportType = ReportType.Detail;
            break;
        case "2":
            reportType = ReportType.Score;
            break;
        case "3":
            reportType = ReportType.Summary;
            break;
        case "4":
            reportType = ReportType.Assessment;
            break;
        case "5":
            reportType = ReportType.Wellness;
            break;
        case "6":
            reportType = ReportType.Movement;
            break;
        case "7":
            reportType = ReportType.WellnessSummary;
            break;
    }

    return (
        <ReportRunner
            reportId={reportId}
            type={reportType}
            userId={userId} />
    );
}

export default GenerateReportPage;